<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Восстановление пароля</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" validation>
              <v-text-field
                  prepend-icon="lock"
                  name="newPassword"
                  label="Новый пароль"
                  type="password"
                  v-model="newPassword"
                  :rules="newPasswordRules"
                  validate-on-blur
                  outline
              ></v-text-field>
              <v-text-field
                  prepend-icon="lock"
                  name="smsCode"
                  label="Смс код"
                  type="text"
                  v-model="smsCode"
                  :rules="smsCodeRules"
                  autocomplete="off"
                  validate-on-blur
                  outline
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="onSubmit"
                :loading="loading"
                :disabled="!valid || loading"
            >Восстановить</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        newPassword: '',
        smsCode: '',
        valid: false,
        newPasswordRules: [
          v => !!v || 'Обязательное поле',
          v => (v && v.length >= 0) || ''
        ],
        smsCodeRules: [
          v => !!v || 'Обязательное поле',
          v => /^[0-9]+$/u.test(v) || 'Код не корректный'
        ]
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      }
    },
    methods: {
      onSubmit () {
        if (this.$refs.form.validate()) {
          const user = {
            newPassword: this.newPassword,
            smsCode: this.smsCode
          }

          this.$store.dispatch('passwordResetValidateUser', user)
            .then(() => {})
            .catch((e) => {
              this.$router.push('/login')
            })
        }
      }
    },
    created () {
      this.$store.commit('setPageTitle', 'Восстановление пароля')
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Auth/PasswordRecoveryConfirm.vue